import React from 'react';
import UDText from '../text';

type Props = {
  children: React.ReactNode;
};

const UDHeaderTitle = (props: Props) => {
  return (
    <UDText type="headline" className="text-DarkBlue">
      {props.children}
    </UDText>
  );
};

export default UDHeaderTitle;
